// QR code SVG -> PNG (hoge resolutie) voor labelprinters, of naar klembord.
export async function qrSvgNaarPngBlob(containerId, pixels = 1024) {
  const svgEl = document.getElementById(containerId)?.querySelector("svg");
  if (!svgEl) throw new Error("QR niet gevonden");
  const svgData = new XMLSerializer().serializeToString(svgEl);
  const url = URL.createObjectURL(new Blob([svgData], { type: "image/svg+xml;charset=utf-8" }));
  try {
    const img = await new Promise((res, rej) => {
      const i = new window.Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = url;
    });
    const canvas = document.createElement("canvas");
    canvas.width = pixels;
    canvas.height = pixels;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, pixels, pixels);
    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(img, 0, 0, pixels, pixels);
    return await new Promise((res) => canvas.toBlob(res, "image/png"));
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function downloadQrPng(containerId, bestandsnaam) {
  const blob = await qrSvgNaarPngBlob(containerId);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${bestandsnaam}.png`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}

export async function copyQrPng(containerId) {
  try {
    const blob = await qrSvgNaarPngBlob(containerId);
    await navigator.clipboard.write([new window.ClipboardItem({ "image/png": blob })]);
    return true;
  } catch (e) {
    return false;
  }
}

// Volledige QR-kaart (firmanaam, QR, kenteken/naam) als PNG — klaar voor labelprinters.
export async function qrKaartPngBlob(containerId, opties = {}) {
  const { titel = "", subtitel = "", label = "", regels = [], breedte = 900 } = opties;
  const svgEl = document.getElementById(containerId)?.querySelector("svg");
  if (!svgEl) throw new Error("QR niet gevonden");
  const svgData = new XMLSerializer().serializeToString(svgEl);
  const url = URL.createObjectURL(new Blob([svgData], { type: "image/svg+xml;charset=utf-8" }));
  try {
    const img = await new Promise((res, rej) => {
      const i = new window.Image();
      i.onload = () => res(i);
      i.onerror = rej;
      i.src = url;
    });

    const pad = 48;
    const qrSize = breedte - pad * 2 - 120;
    let y = pad + 40;
    const hoogte =
      pad * 2 +
      (titel ? 70 : 0) +
      (subtitel ? 34 : 0) +
      40 +
      qrSize +
      (label ? 110 : 0) +
      regels.length * 36 +
      60;

    const canvas = document.createElement("canvas");
    canvas.width = breedte;
    canvas.height = hoogte;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, breedte, hoogte);

    // kader
    ctx.strokeStyle = "#111111";
    ctx.lineWidth = 8;
    ctx.strokeRect(16, 16, breedte - 32, hoogte - 32);

    ctx.textAlign = "center";
    const mid = breedte / 2;

    if (titel) {
      ctx.fillStyle = "#111111";
      ctx.font = "bold 46px Arial, Helvetica, sans-serif";
      ctx.fillText(titel, mid, y + 10);
      y += 62;
    }
    if (subtitel) {
      ctx.fillStyle = "#888888";
      ctx.font = "20px Arial, Helvetica, sans-serif";
      ctx.fillText(subtitel, mid, y);
      y += 30;
    }

    ctx.strokeStyle = "#cccccc";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(mid - 60, y + 8);
    ctx.lineTo(mid + 60, y + 8);
    ctx.stroke();
    y += 40;

    ctx.imageSmoothingEnabled = false;
    ctx.drawImage(img, mid - qrSize / 2, y, qrSize, qrSize);
    y += qrSize + 40;

    if (label) {
      ctx.font = "bold 44px 'Courier New', monospace";
      if ("letterSpacing" in ctx) ctx.letterSpacing = "8px";
      const tekstBreedte = ctx.measureText(label).width;
      const boxB = Math.min(breedte - pad * 2, tekstBreedte + 70);
      ctx.strokeStyle = "#111111";
      ctx.lineWidth = 5;
      ctx.strokeRect(mid - boxB / 2, y - 8, boxB, 76);
      ctx.fillStyle = "#111111";
      ctx.fillText(label, mid + 4, y + 46);
      if ("letterSpacing" in ctx) ctx.letterSpacing = "0px";
      y += 100;
    }

    ctx.fillStyle = "#555555";
    ctx.font = "24px Arial, Helvetica, sans-serif";
    regels.filter(Boolean).forEach((r) => {
      ctx.fillText(String(r), mid, y + 24);
      y += 36;
    });

    return await new Promise((res) => canvas.toBlob(res, "image/png"));
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function downloadQrKaart(containerId, bestandsnaam, opties) {
  const blob = await qrKaartPngBlob(containerId, opties);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${bestandsnaam}.png`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}

export async function copyQrKaart(containerId, opties) {
  try {
    const blob = await qrKaartPngBlob(containerId, opties);
    await navigator.clipboard.write([new window.ClipboardItem({ "image/png": blob })]);
    return true;
  } catch (e) {
    return false;
  }
}
